import script from "./ListSensors.vue?vue&type=script&setup=true&lang=js"
export * from "./ListSensors.vue?vue&type=script&setup=true&lang=js"

import "./ListSensors.vue?vue&type=style&index=0&id=52a8e6e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52a8e6e8"]])

export default __exports__